import React from 'react';
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldValues,
  Path,
} from 'react-hook-form';
import {StyleSheet, View, ViewStyle} from 'react-native';

import {ErrorMessage} from './ErrorMessage';
import {ValidationError} from './ValidationError';

interface Props<T extends FieldValues, K extends Path<T>> {
  control: Control<T>;
  name: K;
  style?: ViewStyle;
  children: (props: ControllerRenderProps<T, K>) => React.ReactNode;
}

export const ValidatedField = <T extends FieldValues, K extends Path<T>>({
  control,
  name,
  style,
  children,
}: Props<T, K>) => (
  <Controller
    {...{control, name}}
    render={({field, formState: {errors}}) => {
      const error = errors[name];

      return (
        <View style={[styles.container, style]}>
          {children(field)}

          <View style={styles.error}>
            {!!error && (
              <ValidationError>
                <ErrorMessage variant="xs" style={styles.message}>
                  {error.message?.toString()}
                </ErrorMessage>
              </ValidationError>
            )}
          </View>
        </View>
      );
    }}
  />
);

const styles = StyleSheet.create({
  container: {
    gap: 8,
    width: '100%',
  },
  error: {
    minHeight: 16,
  },
  message: {
    flex: 1,
    textAlign: 'left',
  },
});
